// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "compareFares-9MgUd";
var _5 = "loaderWrp-TY9Dq";
var _6 = "loader-1GpYk";
var _7 = "container-cNVjI";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "compareFares", _5 as "loaderWrp", _6 as "loader", _7 as "container" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "compareFares": _4, "loaderWrp": _5, "loader": _6, "container": _7 }
